import { z } from 'zod'
import { mixerInputVideoSchema, mixerInputAudioSchema } from '../../pads'

export const sceneChangeSchema = z.object({
  padName: z.string(),
  transitionDurationMs: z.number().nullable(),
  video: mixerInputVideoSchema.partial().nullable(),
  audio: mixerInputAudioSchema.partial().nullable(),
})
export type SceneChanges = z.infer<typeof sceneChangeSchema>

export const sceneIdSchema = z.string().min(1)
export type SceneId = z.infer<typeof sceneIdSchema>

export const sceneSchema = z.object({
  sceneId: sceneIdSchema,
  displayName: z.string().nullish(),
  defaultTransitionDurationMs: z.number().nullish(),
  changes: sceneChangeSchema.array(),
})
export type Scene = z.infer<typeof sceneSchema>
